<script setup lang="ts">
import AuSkeletonWrapper from '~/components/ui/AuSkeletonWrapper.vue'
import AuSkeleton from '~/components/ui/AuSkeleton.vue'
</script>

<template>
  <AuSkeletonWrapper>
    <div class="border-green-40 flex w-full items-stretch overflow-hidden rounded-lg border bg-white">
      <div class="grid flex-1 grid-cols-1 items-start gap-2 p-2.5 md:grid-cols-3 md:gap-4">
        <div class="min-w-0 flex-1">
          <div class="min-h-5">
            <AuSkeleton height="1.25rem" width="70%" />
          </div>
          <div class="mt-1">
            <AuSkeleton height="1rem" width="85%" />
          </div>
        </div>

        <div class="flex items-center gap-2">
          <AuSkeleton height="1rem" width="4rem" />
          <AuSkeleton
            height="1.5rem"
            width="1.5rem"
            border-radius="50%"
          />
        </div>
      </div>

      <div class="w-8" />
    </div>
  </AuSkeletonWrapper>
</template>
